import numberFormatter from 'number-formatter';

export function isNumberOrEmpty(value) {
  const reg = /^[0-9]*$/;
  let result = false;
  if (value.match(reg) || value === '') {
    result = true;
  }
  return result;
}

export function isNumber(value) {
  const reg = /^[0-9]+$/;
  let result = false;
  if (value.match(reg)) {
    result = true;
  }
  return result;
}

export function formatMonto(value) {
  let result = '';
  const monto = Number(value);
  if (!isNaN(monto)) {
    result = monto.toLocaleString('de-DE');
    if (result === '0') {
      result = '';
    }
  }
  return result;
}

export function formatMontoWithZero(value) {
  let result = '';
  const monto = Number(value);
  if (!isNaN(monto)) {
    result = monto.toLocaleString('de-DE');
  }
  return result;
}

export function formatTasa(value) {
  let result = '';
  const monto = Number(value);
  if (!isNaN(monto)) {
    result = numberFormatter('#.###.##0,00', monto);
  }
  return result;
}

export function unformat(value) {
  const result = value.replace(/\$/g, '').replace(/\./g, '').replace(/,/g, '').trim();
  return result;
}

export function formatNumeroCuenta(value) {
  let result = value;
  if (result) {
    while (result.length < 16) {
      result = 'X' + result;
    }
    result = result.substring(0, 4) + '-' + result.substring(4, 8) + '-' + result.substring(8, 12) + '-' + result.substring(12, 16);
  }
  return result;
}
